<template>
  <app-bar :is-login="false"/>
  <v-main class="login-main d-flex align-center">
    <v-container class="my-auto bg-white rounded-lg">
      <v-row v-if="successMessage" justify="center" class="mt-5 mb-3">
        <div class="font-weight-bold text-glance-primary text-center">
          {{ successMessage }}
        </div>
      </v-row>
      <v-row class="mt-5 mb-3">
        <v-col class="d-flex justify-end mr-2">
          <img src="@/images/obstetrics_logo.png" height="50px"alt="Obstetrics Logo">
        </v-col>
        <v-col class="d-flex justify-start ml-2">
          <img src="@/images/syounika_logo.png" height="50px"alt="Syounika Logo">
        </v-col>
      </v-row>
      <v-row class="my-4 font-size-10-rem">
        このページにログインすると、株式会社Kids Publicが提供する「産婦人科・小児科オンライン」の利用状況をご確認できます。
      </v-row>
      <v-row class="mb-5">
        <v-form class="w-100">
          <div class="my-2">
            <v-label
              text="メールアドレス"
              class="font-weight-bold text-black pb-1"/>
            <v-text-field
              v-model="email"
              variant="outlined"
              name="email"
              type="text"
              rounded="lg"
              :color="color.mainColor()"
              single-line
            />
          </div>
          <div class="my-2">
            <v-label
              text="パスワード"
              class="font-weight-bold text-black pb-1"/>
            <v-text-field
              v-model="password"
              variant="outlined"
              name="password"
              :type="showPassword ? 'text' : 'password'"
              :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              :color="color.mainColor()"
              @click:append-inner="showPassword = !showPassword"
              single-line
            >
            </v-text-field>
        </div>
        <div class="font-weight-bold text-glance-accent">
          {{ errorMessage }}
        </div>
        <div class="text-center mt-8">
          <v-btn
            variant="flat"
            :color="color.mainColor()"
            size="large"
            rounded="lg"
            class="text-white font-weight-bold"
            @click="login">
            ログイン
          </v-btn>
        </div>
        <div class="text-center font-size-075-rem my-5">
          ※ログインできない場合は、株式会社Kids Publicの担当者までお問い合わせください。
        </div>
        </v-form>
      </v-row>
    </v-container>
  </v-main>
  <div class="mb-3 text-center ">
    <copyright />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue"
import { useStore } from "../stores/index"
import router from "../router/index"
import { useRoute } from "vue-router"
import { themeColor } from "../service/theme_color"
import appBar from "./shared/AppBar.vue"
import copyright from "./shared/Copyright.vue"

export default defineComponent({
  name: "LoginPage",
  components: {
    appBar,
    copyright
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    // settings
    const color = themeColor()

    const email = ref("")
    const password = ref("")
    const errorMessage = ref("")
    const successMessage = ref("")
    const redirectPath = ref("/")
    const showPassword = ref(false)

    onMounted(() =>{
      if(typeof route.query.redirectTo === "string"){
        redirectPath.value = route.query.redirectTo
      }
      if(route.query.invitationAccepted === "true"){
        successMessage.value = "パスワードの設定が完了しました。設定したパスワードでログインしてください。"
      }
    })

    const login = async () =>{
      await store.dispatch("signIn", { email: email.value, password: password.value }).then(() => {
        router.push(redirectPath.value)
      }).catch(() => {
        errorMessage.value = "メールアドレスまたはパスワードが正しくありません。もう一度ご確認ください。"
      })
    }

    return {
      email,
      password,
      errorMessage,
      successMessage,
      login,
      color,
      showPassword
    }
  }
})
</script>
<style lang="scss">
.login-main{
  margin-top: -50px;

  .v-container {
    max-width: 800px;
    padding-left: 100px;
    padding-right: 100px;

    .v-form{
      .v-label{
        opacity: 1;
      }
      .v-text-field{
        .v-field__outline{
          border-radius: 15px;
        }
        .v-field__append-inner{
          .v-icon {
            opacity: 1;
          }
        }
      }
    }
  }
  /** アプリによる自動入力時に設定されるinput要素の背景色を角丸にする */
  input[name="email"] {
    border-radius: 15px;
  }
  input[name="password"] {
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
  }
}
</style>
